import { ID } from "src/libs/interfaces/layouts"
import FieldInput from "src/libs/scalars"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingContent, ILandingFloat, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { LANDING_SCALAR } from "src/modules/pe-landing-module/data/landin_scalars"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"
import LandingCompositeWidget from "src/modules/pe-landing-module/widgets/LandingCompositeWidget"
import updateSection from "../utils/updateSection"



const AnimationPanel = ( ): JSX.Element => { 
    const animationType             = useLandingConsoleStore((state: ILandingConsoleStore) => state.animationType)
    const animationDelay            = useLandingConsoleStore((state: ILandingConsoleStore) => state.animationDelay)
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const selectedLayer : ID        = useLandingStore((state: ILandingStore) => state.selectedLayer)
    const selectedData              = useSelectedContent()

    const getAnimationType = () => { 
        
        // 
        
        switch (selectedData.type ) {
                case SELECT_TYPE.CONTENT: 
                case SELECT_TYPE.FLOAT:    
                case SELECT_TYPE.TITLE:                    
                    return selectedData.data
                case SELECT_TYPE.NONE:
                default:
                    return { animated: animationType, animated_delay: animationDelay }
            }
    }
    const onAnimationType = (value: any, field: string) => {  
        let step:IHistoryStep = {
            type: HISTORY_TYPE.SECTION,
            data: null,
            prevData: null,
            title: ""
        }, id: ID

        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                id = selectedData.data.id 
                step.prevData = JSON.parse(JSON.stringify(currentLanding.sections.find(section => section.id === selectedLayer) || {}))
                step.data = {
                    ...step.prevData,
                    data: step.prevData.data?.map((meat: ILandingContent) => {
                        if( meat.id === id ) {
                            return {
                                ...meat,
                                animated:  value,
                                animated_delay:  value.animated_delay,
                            }
                        }
                        return meat
                    }) 
                }
                step.title = "Change meat animation"
                updateSection(step.data, step) 
                return
            case SELECT_TYPE.FLOAT: 
                id = selectedData.data.id 
                step.prevData = JSON.parse(JSON.stringify(currentLanding.sections.find(section => section.id === selectedLayer) || {}))
                step.data = {
                    ...step.prevData,
                    floats: step.prevData.floats?.map((float: ILandingFloat) => {
                        if( float.id === id ) {
                            
                            console.log( id, value, field )
                            
                            return {
                                ...float,
                                animated:  value,
                                animated_delay:  value.animated_delay,
                            }
                        }
                        return float
                    }) 
                }
                step.title = "Change float animation"
                updateSection(step.data, step) 
                return  
            case SELECT_TYPE.TITLE:
                id = selectedData.data.id 
                step.prevData = JSON.parse(JSON.stringify(currentLanding.sections.find(section => section.id === selectedLayer) || {}))
                step.data = {
                    ...step.prevData,
                    title: {
                        ...step.prevData.title,
                        animated:  value,
                        animated_delay:  value.animated_delay,
                    }
                }
                step.title = "Change title animation" 
                updateSection(step.data, step) 
                return 
            case SELECT_TYPE.NONE:
            default:
                useLandingConsoleStore.setState({ 
                    animated:  value,
                    animated_delay:  value.animated_delay
                })
                return 
        }
    } 

    return <div className="landing-edit-layer"> 
            <div className="panel-list-2 overflow-y-auto pb-3">
                <div className="container pr-0 pl-4">
                    <LandingCompositeWidget
                        type={ LANDING_SCALAR.ANIMATED }
                        dataSection="section"
                        dataName="animated"
                        editable
                        value={ getAnimationType() }
                        origin={ getAnimationType() }
                        onChange={ onAnimationType } 
                    />
                </div>


            </div> 
        </div>
}

export default AnimationPanel